import ViewController from "./class.ViewController.js";

export const cache = {
	tips: null,
	html: {},
};

export default class TransporterTips extends ViewController {
	constructor(options) {
		super(options);

		this.content = [];
		this.page = 0;

		this.ajaxRunner = new AoPS.Ajax.ScriptRunner("/s/transporter/ajax.php", {
			filter_interval: 0,
		});

		// Get the tips!
		this.getTips().catch((error) => {
			console.warn(error);
		});

		this.buildTipMenu();
	}

	/**
	 * Builds the tip menu.
	 */
	buildTipMenu() {
		this.$el.click((event) => {
			if ($(event.target).is(this.$el)) {
				this.toggleTipModal();
			}
		});

		// build the tip menu
		this.$tipMenu = $(`<div class="tip-menu"></div>`).appendTo(this.$el).hide();

		// Tip title.
		this.$tipMenu.append(
			$(`<div class="tip-title"><span>Formatting Tips</span></div>`)
		);

		// Close button
		this.$tipMenu.append(
			$(`<span class="close aops-font">J</span>`).click(() => {
				this.toggleTipModal();
			})
		);

		// Modal content
		this.$tipMain = $(`<div class="tip-main"/>`);
		this.$tipContent = $(`<div class="tip-content"/>`).appendTo(this.$tipMain);
		this.$tipNav = $(`<div class="tip-nav"/>`).appendTo(this.$tipMain);
		this.$tipNavLeft = $(
			`<span class="tip-left tip-nav-item"><span class="aops-font">6</span>Previous Tip</span>`
		)
			.click(() => {
				this.onPreviousTip();
			})
			.appendTo(this.$tipNav);
		this.$tipNavRight = $(
			`<span class="tip-right tip-nav-item">Next Tip<span class="aops-font">7<span></span>`
		)
			.click(() => {
				this.onNextTip();
			})
			.appendTo(this.$tipNav);

		this.$tipMenu.append(this.$tipMain);
	}

	/**
	 * When the user clicks the Previous Tip Button.
	 */
	onPreviousTip() {
		this.page = Math.max(0, this.page - 1);
		this.updateTipMain();
	}

	/**
	 * When the user clicks the Next Tip button.
	 */
	onNextTip() {
		this.page = Math.min(this.content.length - 1, this.page + 1);
		this.updateTipMain();
	}

	/**
	 * Sets the HTML of the tip main modal
	 * and hides the nav arrows if at the beginning/end of the
	 * current set of tip content.
	 */
	updateTipMain() {
		this.$tipContent.html(this.content[this.page]);
		this.$tipNav.show();
		this.$tipNavLeft.show();
		this.$tipNavRight.show();
		if (this.page === 0) {
			this.$tipNavLeft.hide();
			if (this.content.length <= 1) {
				this.$tipNavRight.hide();
				this.$tipNav.hide();
			}
		} else if (this.page === this.content.length - 1) {
			this.$tipNavRight.hide();
		}
	}

	/**
	 * Toggles the tip modal.
	 */
	toggleTipModal() {
		this.$tipMenu.fadeToggle(200);
		this.$el.toggleClass("dimmed");
		this.mainView.$el.find(".menu-icon").fadeToggle(200);
	}

	/**
	 * Populates the tip modal with html content.
	 * @param {Array<string>} html
	 */
	setContent(html) {
		if (_.isArray(html)) {
			this.content = html;
			this.page = 0;
			this.updateTipMain();
		}
	}

	/**
	 * Gets all the tips.
	 */
	getTips() {
		return new Promise((resolve, reject) => {
			if (!cache.tips) {
				this.ajaxRunner.run("get_tips", {}, (success, result) => {
					if (success) {
						cache.tips = result.response.tips;
						for (let tip of cache.tips) {
							if (tip.avoid_parser_type) {
								// This is named verbatim in Transporter.
								if (tip.avoid_parser_type.match("exactmatch")) {
									tip.avoid_answer_type = tip.avoid_parser_type.replace(
										"exactmatch",
										"verbatim|stringmatch"
									);
								} else {
									tip.avoid_answer_type = null;
								}
							}
						}
						resolve(cache.tips);
					} else {
						reject(result);
					}
				});
			} else {
				resolve(cache.tips);
			}
		});
	}

	/**
	 * Gets the HTML for a tip.
	 * @param {string} key the text_key of the tip.
	 * @return {Promise<string>} A promise resolving with an HTML string.
	 */
	getTipHTML(key) {
		return new Promise((resolve, reject) => {
			if (!cache.html[key]) {
				this.ajaxRunner.run("get_tip", {tip_name: key}, (success, result) => {
					if (success) {
						cache.html[key] = result.response.tip;
						resolve(cache.html[key]);
					} else {
						reject(result);
					}
				});
			} else {
				resolve(cache.html[key]);
			}
		});
	}

	/**
	 * Gets the HTML for many tips.
	 * @param {string[]} keys
	 * @return {Promise<string[]>} A promise resolving with an array of HTML strings.
	 */
	getManyTipHTML(keys) {
		const promises = [];
		for (let key of keys) {
			promises.push(this.getTipHTML(key));
		}
		return Promise.all(promises);
	}

	/**
	 * Returns a list of text_keys based on a supplied set of
	 * parseable options.
	 */
	async computeMatchingTips(options) {
		const tips = await this.getTips();
		// eslint-disable-next-line no-undef
		const result = new Set();

		for (let tip of tips) {
			// Convert strings to regexps
			const pattern = tip.pattern && this.stringToRegExp(tip.pattern);
			const avoidPattern =
				tip.avoid_pattern && this.stringToRegExp(tip.avoid_pattern);
			const avoidAnswerType =
				tip.avoid_answer_type && this.stringToRegExp(tip.avoid_answer_type);
			const avoidParserType =
				tip.avoid_parser_type && this.stringToRegExp(tip.avoid_parser_type);

			for (let option of options) {
				// Should we avoid this option based on answer type?
				if (avoidParserType && avoidParserType.test(option.parser_type)) {
					continue;
				}
				if (tip.type === "response") {
					// Is this not a standard parser option?
					if (option.parser_type && option.parser_type !== "standard") {
						continue;
					}
					// Should we avoid this option based on answer type?
					if (avoidAnswerType && avoidAnswerType.test(option.answer_type)) {
						continue;
					} else {
						for (let match of option.match) {
							// Should we avoid this match based on pattern?
							if (avoidPattern && avoidPattern.test(match)) {
								continue;
							} else if (pattern && pattern.test(match)) {
								// This pattern matches!
								result.add(tip);
							}
						}
					}
				} else if (tip.type === "parser_type") {
					// This tip is a parser tip.
					if (tip.pattern === option.answer_type) {
						result.add(tip);
					}
				}
			}
		}

		return [...result]
			.sort((a, b) => {
				if (a.level < b.level) {
					return -1;
				} else if (a.level === b.level) {
					return 0;
				} else {
					return 1;
				}
			})
			.map((tip) => tip.text_key);
	}

	/**
	 * Converts a string to a RegExp
	 * @param {string} str
	 * @return {RegExp}
	 */
	stringToRegExp(str) {
		let lastSlash = str.lastIndexOf("/");
		if (lastSlash < 0) {
			str = `/${str}/i`;
			lastSlash = str.lastIndexOf("/");
		}
		return new RegExp(
			str.slice(1, lastSlash).trim(),
			str.slice(lastSlash + 1).trim()
		);
	}
}
